/* eslint-disable */
export const BUILDVARS = {
  "hashes": {
    "creatures": "58cf94f4b520776624bfe162d5c8a56e",
    "decor": "6b385dc791b0e787673ebbf0d006382e",
    "effects": "7dccbfe57bd86325074622ca2716d2d3",
    "items": "5612094367be2e84dd34cba79c50c17c",
    "swimming": "1a4540483aad852eba348d47a6550a27",
    "terrain": "b711c873655488ede38aacceb7ef59e1",
    "walls": "0a970dea273a4b462b43cdcb74db6d96",
    "itemsanimations": "beaed9503f3d703bd56331b88a57a786",
    "decoranimations": "215226d02d1d80c138dfb7f2ca000da0",
    "terrainanimations": "b4c69315a3b5f41213062881b6b57eb4"
  },
  "version": {
    "dirty": false,
    "raw": "fda9d2c",
    "hash": "fda9d2c",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "fda9d2c",
    "semverString": null
  }
};